
import React from "react";
import './AdminUserManagement.scss';

const AdminUserManagement: React.FC = () => {
  return (
   <div className="AdminUserManagement">This is User management page</div>
  );
};

export default AdminUserManagement;